module.exports = __webpack_public_path__ + "static/media/schedule_structure_add_a_rotating_period.96564956.mov";